import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-refresh",
  "use": "icon-refresh-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-refresh\"><defs><style type=\"text/css\"></style></defs><path d=\"M134.8 512.2c31.6 0 58.5-22.9 63.9-54.1 25.7-149.5 155.9-263.2 312.7-263.2 88.2 0 168 36 225.5 94.1l-79.6 79.6c-11.8 11.8-3.4 31.9 13.2 31.9h251.7c10.3 0 18.7-8.3 18.7-18.7V130.1c0-16.6-20.1-24.9-31.8-13.2l-80.6 80.6c-80.9-81.5-193.1-132-317.1-132-220.9 0-404.4 160.4-440.4 371-6.8 39.6 23.6 75.7 63.8 75.7zM889.7 512.2c-31.6 0-58.5 22.9-63.9 54.1-25.7 149.5-155.9 263.2-312.7 263.2-88.2 0-168-36-225.5-94.1l79.6-79.6c11.8-11.8 3.4-31.9-13.2-31.9H102.3c-10.3 0-18.7 8.3-18.7 18.7v251.7c0 16.6 20.1 24.9 31.8 13.2l80.6-80.6c80.9 81.5 193.1 132 317.1 132 220.9 0 404.4-160.4 440.4-371 6.8-39.5-23.7-75.7-63.8-75.7z\" fill=\"#555555\" p-id=\"2402\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/refresh.svg
// module id = SLu3
// module chunks = 25